/** Idempotency ključevi za naplatu/fiskalizaciju - generisani na klijentu.
 * `crypto.randomUUID()` zahteva "siguran kontekst" (HTTPS ili localhost) -
 * van toga baca grešku, što je izgledalo kao da dugme "ne radi" jer se
 * greška dešava PRE nego što zahtev uopšte krene ka serveru. Fallback ispod
 * radi svuda. */
export function randomUUID(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    try {
      return crypto.randomUUID();
    } catch {
      // padni na fallback ispod
    }
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
